// Module
var code = `<div ng-class="\$ctrl.heightClass || 'h-75'"></div> <div class="mt-2" ng-if="\$ctrl.onMarkersUpdate && \$ctrl.canRemoveLastPin()"> <button type="button" class="btn-flat border border-gray-300 text-gray-700" ng-click="\$ctrl.removeLastPin()" translate> dynamicMap.REMOVE_LAST_PIN </button> </div> `;
// Exports
export default code;